import { render, staticRenderFns } from "./offshore.vue?vue&type=template&id=21e0da29&scoped=true"
import script from "./offshore?vue&type=script&lang=js&external"
export * from "./offshore?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0da29",
  null
  
)

export default component.exports